import { render } from "./Signature.vue?vue&type=template&id=3cd92f43"
const script = {}

import exportComponent from "/app/tmp/360pt/V3/v2026.6.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__